import actions from "./actions";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: {
    tableLoading: false,
    shiftTypes: [],
    workShifts: [],
    assignables: [],
    branches: [],
    currentPage: 1,
    totalWorkShifts: null,
    perPage: 5,
    searchQuery: "",
    filterValue: null,
    allRoster: [],
    totalRoster: null,
    departments: [],
    rosterParam: {},
    rosterDates: [],
    payload: null,
  },
  actions,
  mutations,
};
